import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '8vh',
    backgroundColor: theme?.designer?.headerBackgroundColor,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1),
    position: 'relative',
  },
  leftWrapper: {
    width: '27%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  rightWrapper: {
    width: '27%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    position: 'absolute',
    right: theme.spacing(1),
  },
  icon: {
    color: theme?.designer?.headerIconColor,
  },
  formControl: {
    width: '46%',
  },
  iconButton: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1),
  },
  primary: {
    backgroundColor: theme?.designer?.primaryButtonBackgroundColor,
    '&:hover': {
      backgroundColor: theme?.designer?.primaryButtonBackgroundColor,
    }
  },
  primaryIconColor: {
    color: theme?.designer?.primaryButtonTextColor,
  }
}));

export default useStyles;
